import {MenuItem, Select} from "@mui/material";
import {useTranslationChange} from "i18nano";
import {useLayoutEffect, useState} from "react";
import {useLanguageStore} from "../stores/languageStore";

interface Language {
    lang: string;
    code: string;
    countryCode: string;
}

interface SelectLanguageComponentProps {
    style?: React.CSSProperties,
    onLanguageChange?: (language: Language) => void
}

const SelectLanguageComponent: React.FC<SelectLanguageComponentProps> = ({style, onLanguageChange}) => {
    const [languages, setLanguages] = useState<Array<{ code: string, lang: string, countryCode: string }>>([]);

    const translation = useTranslationChange();
    
    const {currentLanguage, setCurrentLanguage} = useLanguageStore();

    useLayoutEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/locales/languages.json`)
            .then(async (response) => {
                const allowedLanguages = await response.json() as Language[];
                setLanguages(allowedLanguages);
                const localStorageLanguage = localStorage.getItem("lang");
                if (localStorageLanguage) {
                    if (allowedLanguages.findIndex(l => l.code === localStorageLanguage) === -1) {
                        setCurrentLanguage("en");
                    } else {
                        setCurrentLanguage(localStorageLanguage);
                    }
                }
            })
    }, [])

    const changeLanguageHandler = (e: any) => {
        setCurrentLanguage(e.target.value);
        translation.change(e.target.value);
        localStorage.setItem("lang", e.target.value);
        onLanguageChange?.(languages.find(l => l.code === e.target.value)!);
    }

    return (
        (<Select
            value={currentLanguage}
            onChange={changeLanguageHandler}
            sx={style}
        >
            {languages.map(item => <MenuItem
                key={`${item.code}-${item.lang}`}
                value={item.code}>
                <img
                    loading="lazy"
                    width="20"
                    src={`https://flagcdn.com/w20/${item.countryCode.toLowerCase()}.png`}
                    srcSet={`https://flagcdn.com/w40/${item.countryCode.toLowerCase()}.png 2x`}
                    alt=""
                    style={{marginRight: 10}}
                />
                {item.lang}
            </MenuItem>)}
        </Select>)
    )
}

export default SelectLanguageComponent;